import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-财务管理",
  "use": "icon-财务管理-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-财务管理\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 64C264.8 64 64 264.8 64 512s200.8 448 448 448 448-200.8 448-448S759.2 64 512 64z m0 832c-212 0-384-172-384-384s172-384 384-384 384 172 384 384-172 384-384 384z m36-448H704v64H544.8v64H704v64H544.8v193.6h-64V640H320v-64h160.8v-64H320v-64h157.6L332 302.4l45.6-45.6 136 136 136-136 45.6 45.6L548 448z\" p-id=\"8365\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/财务管理.svg
// module id = 2Jxc
// module chunks = 28